import OtherItem from "../otheritems/OtherItem";
import './FriedItem.css';

const FriedItem = ({item}) => {
    return <div className="FriedItem_container">
        <h3>{item.subtitle}</h3><br/>
        {
            item.subitems.map((subitem,index)=><OtherItem key={subitem.name} name={subitem.name} price={subitem.price}/>)
        }
    </div>;
}
 
export default FriedItem;